module.exports = __webpack_public_path__ + "static/media/2020.7.8未成年人暑假安全知识培训.e5e515a9.jpg";